module.exports = __webpack_public_path__ + "static/media/backspace.a97c2425.svg";